import { Grid } from '@mui/material'
import React from 'react'
// import KycTable from './Components/KYC Upload/Kyc_table'
import SubCard from 'ui-component/cards/SubCard'
import KycTabs from './Components/AecList/Tabs'

const AecList=()=> {
  return (
    <Grid container>
        <Grid item xl={12} lg={12} md={12} sm={12}>
            <SubCard title="AEC  List">
                <Grid container>
                    <Grid item xl={12} lg={12} md={12} sm={12}>
                        <KycTabs/>
                    </Grid>
                </Grid>
            </SubCard>
        </Grid>
    </Grid>
  )
}

export default AecList
